import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "item-wrap" }
const _hoisted_3 = { class: "item-return-options" }
const _hoisted_4 = { class: "return-reason" }
const _hoisted_5 = { class: "reason-placeholder" }
const _hoisted_6 = {
  key: 0,
  class: "reason-text"
}
const _hoisted_7 = { class: "return-note" }
const _hoisted_8 = {
  key: 0,
  class: "item-pictures"
}
const _hoisted_9 = { class: "item-pictures-placeholder" }
const _hoisted_10 = { class: "pictures" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_12 = {
  key: 1,
  class: "empty-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemDetail = _resolveComponent("ItemDetail")!
  const _component_ClickablePicture = _resolveComponent("ClickablePicture")!
  const _component_CustomCard = _resolveComponent("CustomCard")!

  return (_openBlock(), _createBlock(_component_CustomCard, { optClass: "t-items" }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.t("TICKET_DETAIL.ITEMS")), 1)
    ]),
    content: _withCtx(() => [
      (_ctx.data.items)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.items, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item,
                class: "ticket-item"
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_ItemDetail, { item: item }, null, 8, ["item"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t("TICKET_DETAIL.REASON")), 1),
                      (item.problemId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.t(`COMMON.CLAIM_REASONS.${item.problemId}`)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.description), 1),
                    (item.uploadedFilesUrl !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t("TICKET_DETAIL.UPLOADED_IMAGES")), 1),
                          _createElementVNode("div", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.uploadedFilesUrl, (picture) => {
                              return (_openBlock(), _createBlock(_component_ClickablePicture, {
                                key: picture,
                                imageUrl: picture.url
                              }, null, 8, ["imageUrl"]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_11
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.t("COMMON.NO_GOODS")), 1))
    ]),
    _: 1
  }))
}